import React, { useState } from 'react';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import useTranslation from 'Hooks/useTranslation';
import { EVENTS, KEYS } from 'Constants/General';
import style from './style';

const { ON_CHANGE } = EVENTS;
const { ENTER } = KEYS;
const { containerSearch } = style;

export default function CustomizedInputBase({ setData, placeholder = null, eventType = ON_CHANGE }) {
  const [search, setSearch] = useState('');
  const { t2 } = useTranslation('Generic');

  if (placeholder === null) placeholder = t2('Search');

  return (
    <Paper form="submit" onSubmit={e => e.preventDefault()} sx={containerSearch} elevation={0}>
      <SearchIcon />
      {eventType === ON_CHANGE ? (
        <InputBase sx={{ ml: 1, flex: 1 }} placeholder={placeholder} onChange={e => setData(e.target.value)} />
      ) : (
        <InputBase
          sx={{ ml: 1, flex: 1 }}
          placeholder={placeholder}
          onKeyDown={e => {
            setSearch(e.target.value);
            if (e.key === ENTER) {
              e.preventDefault();
              setData(search);
            }
          }}
        />
      )}
    </Paper>
  );
}
